const mutations = {
  SET_USER_THEME (state, user_theme) {
    state.user_theme = user_theme
  }
}

export default mutations
